'use client';
import './mobileIntro.scss';

import React, { useEffect, useRef, useState } from 'react';

/* eslint-disable @next/next/no-img-element */
import { Dialog } from '@mui/material';

import MobileIntroScreen from './mobileIntroScreen';
import ExploreScreen from './exploreScreen';
import SatelliteImageryScreen from './satelliteImageryRoleScreen';
import NeedImageScreen from './needImageScreen';
import MobileIntroForm from './mobileIntroForm';
import { getDeviceType } from '@/lib/utils';
import { isPlatformExplore } from '@/constants';
import { MixpanelTracking } from '@/services/mixpanel';
import { MixpanelEvent } from '@/services/eventEnums';
// import { MobileIntoDialog } from '../cartInterfaces';

export default function MobileIntoDialog({
  // openDialog,
  // setOpenDialog,
  searchBarProps,
  searchData,
  searchButtonProps,
}: {
  // openDialog: any;
  // setOpenDialog: any;
  searchBarProps: any;
  searchData: any;
  searchButtonProps: any;
}) {
  const [showContentComponent, setShowContentComponent] = useState({
    mobileIntroScreen: true,
    organizationalImage: false,
    needImage: false,
    explore: false,
    mobileIntroForm: false,
  });

  const [userRole, setUserRole] = useState('');
  const [open, setOpen] = useState(false);
  const dialogFlowRef = useRef('');

  useEffect(() => {
    // Handle SearchParam Override for Mobile Intro Dialog

    if (searchData?.intro_modal === 'false') {
      sessionStorage.setItem('ex_mbl_dlg', 'true');
      return;
    }

    if (searchData?.intro_modal === 'true') {
      sessionStorage.setItem('ex_mbl_dlg', 'false');
    }

    const dialogAlreadyShown = sessionStorage.getItem('ex_mbl_dlg');
    const parsedDialogAlreadyShown = JSON.parse(dialogAlreadyShown || 'false');
    if (parsedDialogAlreadyShown) {
      return;
    }
    const deviceTypeValue = getDeviceType();
    const checkForMobileIntroDialog = deviceTypeValue === 'Mobile' && isPlatformExplore;
    setOpen(checkForMobileIntroDialog);
    sessionStorage.setItem('ex_mbl_dlg', 'true');
    if (checkForMobileIntroDialog) {
      MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_DIALOG_OPEN);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = (): void => {
    setOpen(false);
  };

  const allSteps = {
    main: {
      mobileIntroScreen: true,
      organizationalImage: false,
      needImage: false,
      explore: false,
      mobileIntroForm: false,
    },
    org_img: {
      mobileIntroScreen: false,
      organizationalImage: true,
      needImage: false,
      explore: false,
      mobileIntroForm: false,
    },
    form: {
      mobileIntroScreen: false,
      organizationalImage: false,
      needImage: false,
      explore: false,
      mobileIntroForm: true,
    },
    need_img: {
      mobileIntroScreen: false,
      organizationalImage: false,
      needImage: true,
      explore: false,
      mobileIntroForm: false,
    },
    explore: {
      mobileIntroScreen: false,
      organizationalImage: false,
      needImage: false,
      explore: true,
      mobileIntroForm: false,
    },
  };

  const componentProps = {
    dialogFlowRef,
    allSteps,
    showContentComponent,
    setShowContentComponent,
    setOpen,
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="skywatch-dialog delete-dialog mbl-into-dialog"
      >
        {/* Dialog Screen */}
        {showContentComponent?.mobileIntroScreen && <MobileIntroScreen {...componentProps} />}
        {/* Role Screen */}
        {showContentComponent?.organizationalImage && (
          <SatelliteImageryScreen
            {...componentProps}
            userRole={userRole}
            setUserRole={setUserRole}
          />
        )}
        {/* Need Image Screen */}
        {showContentComponent?.needImage && (
          <NeedImageScreen
            {...componentProps}
            searchBarProps={searchBarProps}
            searchButtonProps={searchButtonProps}
          />
        )}
        {/* Continue Exploring Screen */}
        {showContentComponent?.explore && <ExploreScreen {...componentProps} />}

        {/* Mobile INtro Form Screen */}
        {showContentComponent?.mobileIntroForm && (
          <MobileIntroForm {...componentProps} userRole={userRole} setUserRole={setUserRole} />
        )}
      </Dialog>
    </>
  );
}
